import { combineEpics } from 'redux-observable';
/**
 * MAUI
 */
import { vivaceEpics } from './views/Vivace.epics';
import { draftMetricsQueryStringEpics } from './views/VivaceUserContext.epics';
import { metricEpics } from './views/Metric/Metric.epics';
export const rootEpic = combineEpics(vivaceEpics, draftMetricsQueryStringEpics, metricEpics);

//# sourceMappingURL=epics.js.map
